<template>
  <el-card class="section-card coming-card" shadow="never">
    <p class="eyebrow">{{ eyebrow }}</p>
    <h2>{{ title }}</h2>
    <p>{{ message }}</p>
  </el-card>
</template>

<script>
export default {
  name: 'ComingSoonPanel',
  props: {
    eyebrow: {
      type: String,
      default: 'Coming Soon',
    },
    title: {
      type: String,
      default: 'Coming soon',
    },
    message: {
      type: String,
      default: 'This section will be available soon.',
    },
  },
}
</script>

<style scoped>
.coming-card {
  min-height: 240px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 22px;
  background:
    radial-gradient(circle at top right, rgba(11, 108, 255, 0.12), transparent 38%),
    linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
}

.eyebrow {
  margin: 0 0 8px;
  color: #0b6cff;
  font-size: 0.82rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

h2 {
  margin: 0 0 8px;
  color: #03241f;
  font-size: 1.7rem;
  font-weight: 850;
}

p:last-child {
  margin: 0;
  color: #486a64;
  max-width: 540px;
}
</style>
